export const getDefaultBannerCreditBalanceState = () => ({
  isChatbot: false,
  isHideAction: false,
  bgColor: 'amber.100',
})

export const getDefaultQuotaBannerState = () => ({
  message: '',
  bannerColorOrType: null,
  button: null,
  isFeatureActive: false,
  bannerItems: [],
  isClosable: false,
  isLoading: false,
  error: null,
})

const normalizeButton = (buttonData) => {
  if (!buttonData || typeof buttonData !== 'object') return null
  return {
    type:
      typeof buttonData.type === 'string' || buttonData.type === null
        ? buttonData.type
        : null,
    text:
      typeof buttonData.text === 'string' || buttonData.text === null
        ? buttonData.text
        : null,
    url:
      typeof buttonData.url === 'string' || buttonData.url === null
        ? buttonData.url
        : null,
  }
}

const normalizeBannerItem = (item) => ({
  message: typeof item.message === 'string' ? item.message : '',
  bannerColorOrType:
    typeof item.banner_color === 'string' ? item.banner_color : null,
  button: normalizeButton(item.button),
  isClosable: item.is_closable === true,
})

export const normalizeQuotaBannerResponse = (response = {}) => {
  const defaultState = getDefaultQuotaBannerState()
  const rawData = response && response.data != null ? response.data : null

  if (Array.isArray(rawData)) {
    return {
      ...defaultState,
      isFeatureActive: rawData[0]?.is_feature_active === true,
      bannerItems: rawData.map(normalizeBannerItem),
    }
  }

  const responseData = rawData && typeof rawData === 'object' ? rawData : {}

  const rawItems = responseData.banner_items
  const bannerItems = Array.isArray(rawItems)
    ? rawItems.map(normalizeBannerItem)
    : []

  return {
    ...defaultState,
    message:
      typeof responseData.message === 'string' ? responseData.message : '',
    bannerColorOrType:
      typeof responseData.banner_color === 'string'
        ? responseData.banner_color
        : null,
    button: normalizeButton(responseData.button),
    isFeatureActive: responseData.is_feature_active === true,
    bannerItems,
    isClosable: responseData.is_closable === true,
  }
}

export const hasUnifiedQuotaBanner = (quotaBanner = {}) => {
  return Boolean(
    quotaBanner.isFeatureActive === true &&
      typeof quotaBanner.message === 'string' &&
      quotaBanner.message.length > 0
  )
}
